module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "app-sidebar col-md-3"
  }, [_c('nav', {
    staticClass: "app-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "home"
    }
  }, [_vm._v("What We Do")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "website-development"
    }
  }, [_vm._v("Website Development")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "front-end-outsourcing"
    }
  }, [_vm._v("Front End Outsourcing")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "technologies"
    }
  }, [_vm._v("Technologies We Use")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "team"
    }
  }, [_vm._v("Who We Are")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "contactus"
    }
  }, [_vm._v("Contact Us")])], 1)])]), _vm._v(" "), (_vm.$route && _vm.$route.name && _vm.$route.name !== 'contactus') ? _c('router-link', {
    staticClass: "btn btn-success btn-block btn-lg text-uppercase hireus",
    attrs: {
      "to": "contactus"
    }
  }, [_vm._v("\n\t\tHire Us "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.$route && _vm.$route.name !== 'home') ? _c('div', {
    staticClass: "tag-cloud"
  }, [_c('h4', [_vm._v("Popular Tags:")]), _vm._v(" "), _vm._l((_vm.tags), function(tag) {
    return _c('router-link', {
      staticClass: "btn btn-default btn-xs",
      attrs: {
        "to": tag.link
      }
    }, [_vm._v(_vm._s(tag.name))])
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a108843c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/appSidebar.vue
// module id = 55
// module chunks = 1